import {useAtomValue} from 'jotai';
import React from 'react';
import {Route, Routes} from 'react-router';
import {NotFoundPage} from '~/entities/fallbacks';
import {TariffDescriptionScreen, TariffName, TariffsPreviewScreen} from '~/processes/tariff-management';
import * as api from '../../api';

export function TariffsPage() {
    const {data: activeTariff, isPending, isError} = useAtomValue(api.userTariff.query);
    if (isPending) {
        return <TariffsPreviewScreen.Skeleton />;
    }
    if (isError) {
        return <TariffsPreviewScreen.Skeleton isError />;
    }
    return (
        <Routes>
            <Route
                index
                element={<TariffsPreviewScreen activeTariff={activeTariff} pathToTariff={t => t.toLowerCase()} />}
            />
            {Object.values(TariffName).map(tariff => (
                <Route
                    key={tariff}
                    path={tariff.toLowerCase()}
                    element={
                        <TariffDescriptionScreen
                            title={tariff}
                            activeTariff={activeTariff}
                            tariffService={api.tariffUpgrade}
                        />
                    }
                />
            ))}
            <Route path='*' element={<NotFoundPage />} />
        </Routes>
    );
}
